<template>
    <div>
        <socials-form 
        :is-socials-form-sidebar-active.sync="isSocialsFormSidebarActive"
            :socials-data="socialsData"
            @refetch-data="refetchData" 
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <v-select
                                    id="category_id"
                                    class="d-inline-block width-350 mr-1"
                                        v-model="catFilter"
                                        placeholder="Filter By Category"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="title"
                                        :reduce="(option) => option.id"
                                        :options="catsData"
                                />
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                            variant="primary"
                            @click="updateSocials()"
                            >
                                <span class="text-nowrap">Add Social</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <!-- <b-table
                v-if="socials.length <= 0"
                :items="socials"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table> -->
            <table class="table table-striped" empty-text="No matching records found">
            <thead>
                <tr>
                <th scope="col" v-for="col in tableColumns">
                    {{col.label}}
                </th>
                </tr>
            </thead>
            <draggable v-model="socials" tag="tbody" hadle=".handle" @change="updateServicesOrdering()">
                <tr v-for="(item, index) in socials" :key="index">
                    <th scope="row" class="pl-2">
                        <MenuIcon icon="MenuIcon" class="handle"/> 
                    </th>
                    <td class="pl-2">
                        <b-img
                        :src="(item.cover_image? item.social_image: require('@/assets/images/no-image.png'))"
                        height="110"
                        width="170"
                        class="rounded m-0"
                        />
                    </td>
                    <td class="pl-2">
                        <span>{{item.title}}</span>
                    </td>
                    <td class="pl-2">
                        <span>{{item.slug}}</span>
                    </td>
                    <td class="pl-2">
                        <span>{{item.category_name}}</span>
                    </td>
                    <td class="pl-2">
                        <b-badge
                        pill
                        :variant="`light-${resolveSocialsStatusVariant(item.is_active)}`"
                        class="text-capitalize"
                        >
                            {{ resolveSocialsStatusnameVariant(item.is_active) }} 
                        </b-badge>
                    </td>
                    <td class="pl-2">
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateSocials(item)" variant="outline-success">Edit</b-button>
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                    </td>
                </tr>
            </draggable>
            </table>

            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalSocials"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
    </template>
    <script>
    import {
      BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
      BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    //api
    import axios from '@axios'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    import useSocialsList from './useSocialsList'

    import socialsStoreModule from '../socialsStoreModule'
    
    import SocialsForm from '../socials-form/SocialsForm.vue'
    import vSelect from 'vue-select'
    import draggable from 'vuedraggable'
    import { MenuIcon } from 'vue-feather-icons'
    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, 
            BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox, SocialsForm, BImg,
            vSelect, draggable, MenuIcon
        },
        directives:{
            'b-modal': VBModal,
            Ripple
    
        },
        setup(){
            const PORTFOLIO_STORE_MODULE_NAME = 'app-socials';
            if (!store.hasModule(PORTFOLIO_STORE_MODULE_NAME)) store.registerModule(PORTFOLIO_STORE_MODULE_NAME, socialsStoreModule)
            onUnmounted(() => {
                if (store.hasModule(PORTFOLIO_STORE_MODULE_NAME)) store.unregisterModule(PORTFOLIO_STORE_MODULE_NAME)
            });
            const {
                isSocialsFormSidebarActive,
                fetchData,
                tableColumns,
                perPage,
                currentPage,
                totalSocials,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refSocialsListTable,
            
                statusFilter,
                catFilter,
                deleteData,
                socialsData,
                catsData,
                updateSocials,
                refetchData,
                resolveSocialsStatusVariant,
                resolveSocialsStatusnameVariant,
                socials,
                updateServicesOrdering
            } = useSocialsList();

            fetchData();
            return {
                isSocialsFormSidebarActive,
                fetchData,
                tableColumns,
                perPage,
                currentPage,
                totalSocials,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refSocialsListTable,
                socialsData,
                catsData,
                statusFilter,
                catFilter,
                deleteData,
        
                updateSocials,
                refetchData,
                resolveSocialsStatusVariant,
                resolveSocialsStatusnameVariant,
                socials,
                updateServicesOrdering
            }
    
    
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Socials ID.'+id, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                    })
                    .then(value => {
                    if(value === true){
                    this.deleteData(id)
                    }
                
                    //this.deleteData(id)
                    })
    
            },
        }
    }
    
    </script>
    